import Vue from 'vue';
import vhtml from 'vhtml-ui';
import router from './router';
import App from './App.vue';

import 'src/utils/ajax';

Vue.use(vhtml);

// eslint-disable-next-line no-new
new Vue({
    el: '#app',
    router,
    render: h => h(App),
});
